import React from 'react';
import PropTypes from 'prop-types';

import Maybe from 'react-maybe';
import { Typo, Separator } from '@ers/ui';

import { Field } from '.';

const isNullOrEmpty = (val) => {
    if (val === null || val === undefined) {
        return true;
    }
    return String(val).extensions.isEmpty();
};

const getVal = (val) => (isNullOrEmpty(val) ? 'brak odpowiedzi' : val);
const renderField = (label, val, renderer, key) => {
    if (renderer) {
        return (
            <Field key={key}>
                {label && <Typo.Caption className="field-label" dangerouslySetInnerHTML={{ __html: label }} />}
                <Typo.Body className="field-body">{renderer(getVal(val))}</Typo.Body>
            </Field>
        );
    }
    return (
        <Field key={key}>
            {label && <Typo.Caption className="field-label" dangerouslySetInnerHTML={{ __html: label }} />}
            <Typo.Body className="field-body" dangerouslySetInnerHTML={{ __html: (getVal(val)) }} />
        </Field>
    );
};

const Section = ({ children }) => (<div className="section">{children({ renderField })}</div>);
const Conditional = ({ condition, children, title }) => (
    <Maybe
        of={condition}
        either={(
            <>
                <Separator />
                {title && <Typo.Subheader>{title}</Typo.Subheader>}
                <Section>{(attrs) => children({ renderField: attrs.renderField })}</Section>
            </>
        )}
        orElse={null}
    />
);
Conditional.propTypes = {
    condition: PropTypes.bool.isRequired,
    title: PropTypes.string
};
Conditional.defaultProps = {
    title: null
};
Section.Conditional = Conditional;
export default Section;
